module.exports = __webpack_public_path__ + "img/couples-083.331e9a86.jpg";